"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RTTI_SubstancePolymer_RepeatUnit = void 0;
var t = __importStar(require("io-ts"));
var RTTI_Extension_1 = require("./RTTI_Extension");
var RTTI_CodeableConcept_1 = require("./RTTI_CodeableConcept");
var RTTI_Element_1 = require("./RTTI_Element");
var RTTI_SubstanceAmount_1 = require("./RTTI_SubstanceAmount");
var RTTI_SubstancePolymer_DegreeOfPolymerisation_1 = require("./RTTI_SubstancePolymer_DegreeOfPolymerisation");
var RTTI_SubstancePolymer_StructuralRepresentation_1 = require("./RTTI_SubstancePolymer_StructuralRepresentation");
exports.RTTI_SubstancePolymer_RepeatUnit = t.recursion('ISubstancePolymer_RepeatUnit', function () {
    return t.partial({
        id: t.string,
        extension: t.array(RTTI_Extension_1.RTTI_Extension),
        modifierExtension: t.array(RTTI_Extension_1.RTTI_Extension),
        orientationOfPolymerisation: RTTI_CodeableConcept_1.RTTI_CodeableConcept,
        repeatUnit: t.string,
        _repeatUnit: RTTI_Element_1.RTTI_Element,
        amount: RTTI_SubstanceAmount_1.RTTI_SubstanceAmount,
        degreeOfPolymerisation: t.array(RTTI_SubstancePolymer_DegreeOfPolymerisation_1.RTTI_SubstancePolymer_DegreeOfPolymerisation),
        structuralRepresentation: t.array(RTTI_SubstancePolymer_StructuralRepresentation_1.RTTI_SubstancePolymer_StructuralRepresentation)
    });
});
//# sourceMappingURL=RTTI_SubstancePolymer_RepeatUnit.js.map